import { Dialog, IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import { useState } from "react";
import { List } from "@mui/icons-material";
import DialogContentSelectProcuradores from "./DialogContentSelectProcuradores";

export default function SelectProcuradores({
    value,
    onChange,
    required = false,
    error = false,
    errorMessage = "",
    extraParams = {},
    label = "Nome comprador"
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)
    const handleOpenModal = () => setOpenModal(true)

    const inputLabel = value ? value : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={label}
                variant="outlined"
                fullWidth
                value={inputLabel}
                helperText={error ? errorMessage : ""}
                onChange={(e) => onChange(e.target.value)}
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                <Tooltip title="Selecionar procurador">
                                    <IconButton
                                        onClick={handleOpenModal}
                                        edge="end"
                                        aria-label="abrir lista de procuradores"
                                    >
                                        <List />
                                    </IconButton>
                                </Tooltip>
                            </InputAdornment>
                        )
                    }
                }}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectProcuradores
                        {...{ extraParams, handleClose }}
                        onSelect={(item) => {
                            onChange(item.nome);
                            handleClose();
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: string
    onChange: (arg: string) => void
    required?: boolean
    error?: boolean
    errorMessage?: string
    extraParams?: { [key: string]: any };
    label?: string
}